/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import { post } from './ApiService';

const baseUrl = {
    billing: 'Billings',
    payment: 'Payments',
};

/**
 * @param {string[]} statuses
 * @param {string} invoiceNumber
 * @param {string[]} [workOrderIds]
 */
export function findWorkOrderBillingByStatuses(
    statuses,
    invoiceNumber,
    workOrderIds
) {
    return post(
        true,
        `${baseUrl.billing}/findWorkOrderBillingByBillingStatuses`,
        { statuses, invoiceNumber, workOrderIds }
    );
}

/**
 * @param {string[]} statuses
 * @param {string} invoiceNumber
 * @param {string[]} [workOrderIds]
 */
export function findWorkOrderPaymentByStatuses(
    statuses,
    invoiceNumber,
    workOrderIds
) {
    return post(
        true,
        `${baseUrl.payment}/findWorkOrderPaymentByPaymentStatuses`,
        { statuses, invoiceNumber, workOrderIds }
    );
}

/**
 * @param {string[]} statuses
 * @param {string} invoiceNumber
 * @param {string[]} [orderIds]
 */
export function findOrderBillingByStatuses(statuses, invoiceNumber, orderIds) {
    return post(true, `${baseUrl.billing}/findOrderBillingByBillingStatuses`, {
        statuses,
        invoiceNumber,
        orderIds,
    });
}

/**
 * @param {string[]} statuses
 * @param {string} invoiceNumber
 * @param {string[]} [orderIds]
 */
export function findOrderPaymentByStatuses(statuses, invoiceNumber, orderIds) {
    return post(true, `${baseUrl.payment}/findOrderPaymentByPaymentStatuses`, {
        statuses,
        invoiceNumber,
        orderIds,
    });
}
